(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.Main = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var $ = jQuery;
var lang = document.querySelector('html').getAttribute('lang');
var logoLink = document.querySelector('.qodef-header-logo-link');
var copy = document.querySelector('#block-29 .wx-text');
var portItem = document.querySelectorAll('.qodef-grid-item.portfolio-item');

if (lang === 'en-US') {
  logoLink.setAttribute('href', '/en/home/');
  copy.innerText = '© 2022 MUSEU DA PESSOA, ALL RIGHTS RESERVED';
} else if (lang === 'es-ES') {
  logoLink.setAttribute('href', '/es/inicio-2/');
  copy.innerText = '© 2022 MUSEU DA PESSOA, TODOS LOS DERECHOS RESERVADOS';
} else if (lang === 'pt-BR') {}

portItem.forEach(function (item) {
  var h4 = item.querySelectorAll('h4');
  var btn = document.createElement("div");
  btn.classList.add('wx-btn');

  if (lang === 'en-US') {
    btn.innerText = 'Access';
  } else if (lang === 'es-ES') {
    btn.innerText = 'Acceso';
  } else if (lang === 'pt-BR') {
    btn.innerText = 'Acessar';
  }

  h4[0].append(btn);
});

},{}]},{},[1])(1)
});
